"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  CREATE: "@@asset/create",
  DOWNLOAD: "@@asset/download",
  GET_ASSETS_PRESIGNED: "@@asset/presigned",
  DOWNLOAD_URL: "@@asset/url",
  UPDATE: "@@asset/update",
  LIST: "@@asset/list",
  DELETE: "@@asset/delete",
  PREVIEW: "@@asset/preview",
  PREVIEW_DOC: "@@asset/preview-doc",
  UPDATE_ACCESS_PERMISSION: "@@asset/update-access-permission",
  CREATE_ACCESS_PERMISSION: "@@asset/create-access-permission",
  COVER_IMAGE: "@@asset/cover-image",
  REPORT_COVER_IMAGE: "@@asset/report-cover-image",
  GET_ACCESS_PERMISSION: "@@asset/get-access-permission",
  SUCCESS: "@@asset/success",
  ERROR: "@@asset/error",
  RESET: "@@asset/reset"
};
exports.actionTypes = actionTypes;